import React from "react";
import { Search } from "lucide-react";
import { adminInput } from "@/components/admin/adminUi";

export default function AdminFilterBar({
  search,
  onSearch,
  searchPlaceholder = "Search…",
  searchTestId,
  children,
  actions,
}) {
  return (
    <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-4 mb-6">
      <div className="flex flex-col lg:flex-row gap-3">
        {onSearch && (
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-white/40 pointer-events-none" />
            <input
              type="search"
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              placeholder={searchPlaceholder}
              data-testid={searchTestId}
              className={`${adminInput} pl-11`}
            />
          </div>
        )}
        {children && (
          <div className="flex flex-col sm:flex-row gap-3 lg:contents">{children}</div>
        )}
        {actions && (
          <div className="flex flex-col sm:flex-row gap-2 lg:ml-auto">{actions}</div>
        )}
      </div>
    </div>
  );
}
